/**
 * composerSlice — composer draft text (current conversation only).
 *
 * Per-conversation persistent config (mode, focus, webSearch,
 * agentMode, connectionIds, folderFilter) lives in
 * `conversationsSlice` under `conversations[id].config` — bound to the
 * conversation, not to the composer instance.
 */

import type { StateCreator } from "zustand";
import type { ChatStore } from "./chatStore";

export interface ComposerSlice {
  composerDraft: string;
  setComposerDraft: (s: string) => void;
}

export const createComposerSlice: StateCreator<
  ChatStore,
  [],
  [],
  ComposerSlice
> = (set) => ({
  composerDraft: "",
  setComposerDraft: (s) => set({ composerDraft: s }),
});
